module.exports = __webpack_public_path__ + "img/6cf4b19.svg";